import React from "react";

import complete from "../../../../../../assets/images/other/stress7.svg";

import "./StressCurve.scss";

export const StressCurve = () => {
  return (
    <div className="stress-graph">
      <h4>Key to the Stress Curve</h4>
      <div className="key-curve">
        <span>
          <h6 className="mt-2">
            The Stress Curve was first developed by Yerkes-Dodson, two
            psychologists back in 1908. We have adapted it from measuring an
            individual to giving an indication of the stress of the whole team.
          </h6>
          <h6 className="mt-2">
            On the far left of the curve, you will see apathy and boredom. With
            an increase in pressure and performance, the teams move first into
            &lsquo;comfort&rsquo; and then into &lsquo;performance&rsquo;.
          </h6>
          <h6 className="mt-2">
            At the top of the curve, the team has a great balance of attainment
            vs pressure - the sweet spot.
          </h6>
          <h6 className="mt-2">
            Too much pressure and the team moves into &lsquo;strain&rsquo; and
            then finally into burnout - resulting in time off work or
            resignations.
          </h6>
        </span>
        <div>
          <img src={complete} alt="Full Graph" width={400} height="auto" />
        </div>
      </div>
    </div>
  );
};
